import Qty from "js-quantities";

// shims for CF-compliant units
function fixUnits(inputUnits) {
  let units = inputUnits;
  if (units.substring(0, 3) === "deg" && units.substring(0, 6) !== "degree") {
    units = units.replace("deg", "temp");
  } else if (units.substring(0, 9) === "delta_deg") {
    units = units.replace("delta_deg", "deg");
  }
  units = units.replace(/ \*\* /g, "^");
  units = units.replace("%", "percent");
  return units;
}

function QtyWrapper(scalar, units) {
  units = fixUnits(units);
  if (scalar === null || typeof scalar === "undefined") {
    return {
      scalar: null,
      units: units,
      to: (newUnits) => QtyWrapper(scalar, newUnits),
    };
  }
  const qty = Qty(scalar, units);
  (function () {
    const originalTo = qty.to;
    qty.to = function () {
      arguments[0] = fixUnits(arguments[0]);
      return originalTo.apply(this, arguments);
    };
  })();
  return qty;
}

const names = {
  tempC: "degrees Celsius",
  tempF: "degrees Fahrenheit",
  tempK: "degrees Kelvin",
  degC: "degrees Celsius",
  degF: "degrees Fahrenheit",
  degK: "degrees Kelvin",
  "mi/hr": "miles per hour",
  "m/s": "meters per second",
  "W/m^2": "Watts per square meter",
  "%": "percent",
  mbar: "millibars",
  inHg: "inches of Mercury",
};
const nameKeys = Object.keys(names);

const unitName = (unit) => {
  unit = fixUnits(unit);
  let aliases = [];
  try {
    aliases = Qty.getAliases(unit);
  } catch (e) {
    aliases = [unit];
  }
  for (let i = 0; i < aliases.length; i++) {
    const idx = nameKeys.indexOf(aliases[i]);
    if (idx !== -1) {
      return names[aliases[i]];
    }
  }
  return unit;
};

export { unitName };

export default QtyWrapper;
